import { DEEPLINK_SCHEME } from './deeplink-scheme';

export function buildShareDeeplink(): string {
  return `${DEEPLINK_SCHEME}share`;
}
